import { VyIcon } from '@vy/ui-design-system';
import { getSelectorAttribute, plansOverviewPageSelectors } from '@vy/app-selectors';
import { isNotNullOrUndefined, withDefault } from '@vy/utils';
import React from 'react';
import { VyTableToolbar } from '../../../../../../components/new-design/table/vy-table-toolbar/vy-table-toolbar';
import { VyFilter } from '../../../../../../components/new-design/table/vy-table-toolbar/vy-table-toolbar-components/VyFilter';
import { useGlobalSearchParams } from '../../../../../../contexts/useSearchParamsContext';
import { useDialog } from '../../../../../../hooks/use-dialog';
import { useSearchWithSearchParams } from '../../../../../../hooks/use-search-with-search-params';
import { PlanCreationOptionsDialog } from '../../../../components/PlanCreationOptionsDialog';
import { PlanFilters } from './PlanFilters';

type PlansOverviewsTableToolbarProps = {
  isFilterPlanOpen: boolean;
  openFilterPlan: () => void;
  closeFilterPlan: () => void;
};

export const PlansOverviewsTableToolbar: React.FC<PlansOverviewsTableToolbarProps> = ({
  closeFilterPlan,
  isFilterPlanOpen,
  openFilterPlan,
}) => {
  const [query, setQuery] = useSearchWithSearchParams();
  const handleFilterClick = () => (isFilterPlanOpen ? closeFilterPlan() : openFilterPlan());
  const isFilterActive = useIsFilterActive();
  const { isDialogOpen, handleOpen, handleClose } = useDialog();

  return (
    <>
      <VyTableToolbar>
        <VyTableToolbar.Queries>
          <VyTableToolbar.SearchInput
            onChange={(event) => setQuery(event.target.value)}
            defaultValue={withDefault(query, '')}
          />
        </VyTableToolbar.Queries>

        <VyTableToolbar.Actions>
          <div className="flex items-end">
            <VyFilter
              isFilterOpen={isFilterPlanOpen}
              handleFilterClick={handleFilterClick}
              isFilterActive={isFilterActive}
            />
          </div>

          <VyTableToolbar.CtaButton
            sx={{ columnGap: '12px' }}
            onClick={handleOpen}
            {...getSelectorAttribute(plansOverviewPageSelectors.createPlanButton)}
          >
            <VyIcon icon="PlusMedium" />
            Create
          </VyTableToolbar.CtaButton>
        </VyTableToolbar.Actions>
      </VyTableToolbar>

      <PlanFilters isOpen={isFilterPlanOpen} />

      <PlanCreationOptionsDialog isOpen={isDialogOpen} onClose={handleClose} />
    </>
  );
};

function useIsFilterActive() {
  const [searchParams] = useGlobalSearchParams();

  return isNotNullOrUndefined(searchParams.get('plansStatuses'));
}
